export default __webpack_public_path__ + "static/moving_dresser-b48c1a8a39751d716ec1e19a7b6df1d7.jpg";